<template>
  <div class="custom-wrapper">
    <h2 :style="makeColor()">ホームページ</h2>
    <div class="-custom-card" style="padding: 8px;">
      <div class="-left-search">
        <b>検索</b>
      </div>
      <div class="-right-search">
        <input class="input is-small" placeholder="検索する" v-model="searchInput"/>
      </div>
    </div>
    <h2 :style="makeColor()">
      <template v-if="searchInput == null">おすすめページ</template>
      <template v-else>検索結果</template>
    </h2>
    <template v-for="(page, idx) in widgetData.homepages">
      <div
        :key="idx"
        class="-custom-card"
        @click="openCompanyPage(page)"
        v-if="searchFilter(idx, page)">
        <div class="-custom-left">
          <img src="@/assets/template/create_import.png" />
        </div>
        <div class="-custom-right">
          <p>{{page.title}}</p>
          <p style="font-size: 12px;">{{page.description}}</p>
          <p style="font-size: 12px; color: rgba(0, 0, 0, 0.2);">詳細を確認する</p>
        </div>
        <a :style="makeColor()" style="position: absolute; right: 8px; top: 22px; font-size: 24px;">
          <span class="mdi mdi-chevron-right"></span>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true
    },
    widgetData: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      searchInput: null,
    }
  },
  methods: {
    changeView (isDetail, isStoryView, viewType) {
      this.$emit('changeView', {
        isDetail: isDetail,
        isStoryView: isStoryView,
        viewType: viewType
      })
    },
    makeColor () {
      return {
        'color': this.color.iconBg + '!important'
      }
    },
    openCompanyPage (page) {
      this.$emit('openCompanyPage', page.url)
      this.changeView(false, true, null)
    },
    searchFilter (idx, page) {
      // 検索何も入力無し
      if (this.searchInput == null) {
        return idx < 5
      } else {
        if (~page.title.toLowerCase().indexOf(this.searchInput.toLowerCase())) return true
        if (~page.description.toLowerCase().indexOf(this.searchInput.toLowerCase())) return true
        if (~page.search_word.toLowerCase().indexOf(this.searchInput.toLowerCase())) return true
      }
      return false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.custom-wrapper {
  border-radius: 8px;
  width: calc(100% - 24px);
  height: auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  margin: 8px;
  padding: 8px 0px;
  h2 {
    width: 100%;
    padding: 8px 16px;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
  }
  .-custom-card {
    position: relative;
    border-radius: 8px;
    height: auto;
    width: calc(100% - 24px);
    margin: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    cursor: pointer;
    transition: 0.5s;
    .-left-search {
      padding: 4px 8px;
      width: 96px;
      text-align: left;
    }
    .-right-search {
      padding: 4px 8px;
      width: calc(100% - 120px);
      text-align: left;
    }
    .-custom-left {
      width: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: auto;
        width:  80px;
        border-radius: 16px;
        padding: 12px;
        object-fit: cover;
      }
    }
    .-custom-right {
      width: calc(100% - 80px);
      padding: 8px;
      text-align: left;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: -16px;
      p {
        padding-left: 8px;
        text-align: left;
        font-size: 13px;
        font-weight: 600;
      }
      button {
        padding: 8px 16px;
        border-radius: 16px;
      }
    }
  }
  .-custom-card:hover {
    transform: scale(1.025);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/CompanyPageContent.vue